<script setup lang="ts">
import { onMounted, provide } from 'vue'
import { usePersistenceStore } from '@/stores/persistence'
import { pinia } from '@/stores/pinia'

const persistenceStore = usePersistenceStore(pinia)

// Initialize persistence on app mount
onMounted(async () => {
  try {
    await persistenceStore.initialize()
    console.log('Persistence layer initialized')
  } catch (error) {
    console.error('Failed to initialize persistence:', error)
  }
})

// Provide app-level state
provide('persistence', persistenceStore)
</script>

<template>
  <router-view />
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
